/**
 * Trial type stack (Nebula Sans). Next inlines NEXT_PUBLIC_* at build time.
 * On: 1, true, yes, on (any case). Off: unset, 0, false, or anything else.
 */
export const USE_NEW_FONTS = ['1', 'true', 'yes', 'on'].includes(
  (process.env.NEXT_PUBLIC_NEW_FONTS || '').toLowerCase()
)
